<template>
  <b-dropdown
    ref="action-dropdown"
    id="action-dropdown"
    :text="$t('actions')"
    class="p-0 w-100"
    toggle-class="poppins btn btn--export-filter w-100 d-flex align-center justify-content-center btn-toolbar-action"
    menu-class="m-0 p-0 shadow-sm border-0"
    no-caret
    variant="upload"
  >
    <template v-slot:button-content>
      <div class="d-flex align-center justify-content-center w-100 px-1">
        <span class="svg-icon me-1">
          <v-icon size="18">mdi-dns</v-icon>
        </span>
        <span>{{ $t("actions") }}</span>
        <span class="svg-icon ms-1 me-0">
          <v-icon size="18">mdi-chevron-down</v-icon>
        </span>
      </div>
    </template>
    <div class="q-status-menu py-1 w-175px">
      <div
        class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
        v-for="(action, index) in types"
        :key="index"
        @click="() => handleClick(action.url)"
      >
        <div
          class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium"
          :class="[
            { 'mt-2': index === 0 },
            { 'mb-2': index === types.length - 1 },
          ]"
        >
          {{ action.name }}
        </div>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
import swalEdited from "@/core/services/AlertServices/SwalEdited";

export default {
  name: "ActionsButton",
  props: ["items", "types", "refresher", "callback"],
  methods: {
    handleClick(url) {
      if (this.$refs["action-dropdown"]) {
        this.$refs["action-dropdown"].hide(true);
      }
      if (this.items.length > 0) {
        if (url === "bulk_update") {
          this.callback[url]();
          return;
        } else {
          const isConfirmationRequired = this.permissions.find(
            (permission) => permission.name === url
          ).is_confirmation_required;

          if (isConfirmationRequired) {
            Swal.fire({
              title: this.$t("are_you_sure"),
              text: this.$t("cannot_revert"),
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: this.$t("yes"),
            }).then((result) => {
              if (result.isConfirmed) {
                this.actionRequest(url);
              }
            });
          } else {
            this.actionRequest(url);
          }
        }
      } else {
        Swal.fire({
          title: this.$t("warning"),
          text: this.$t("please_select_item"),
          icon: "warning",
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: this.$t("form_ok"),
          cancelButtonColor: "#FFA800",
        });
      }
    },
    actionRequest(url) {
      this.$store.commit(SET_PAGE_LOADING, true);
      let selectedItemsIds = this.items.map((item) => item.id);
      // let data = { [`${this.page}`]: selectedItemsIds };
      let data = { asn_ids: selectedItemsIds };
      ApiService.post(`/fulfillment/asn/${url}`, data)
        .then(({ data }) => {
          let editedItemMessage = `<div><ol>`;
          const { failed_orders, successful_orders } = data.messages;
          [...failed_orders, ...successful_orders].forEach((item) => {
            editedItemMessage += `<li>${item}</li>`;
          });
          editedItemMessage = editedItemMessage + `</ol></div>`;
          Swal.fire({
            title: this.$t("result"),
            html: editedItemMessage,
            icon: data.error_orders === 0 ? "success" : "warning",
            showConfirmButton: true,
          });
          this.refresher();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
  computed: {
    permissions: function () {
      return this.$store.getters.getASNTablePermissions;
    },
  },
};
</script>
